import { useRoute } from "vue-router";

export const useNavigatingLinks = (facets) => {
  const route = useRoute();

  const navigationLink = (item, attribute, page = "listing") => {
    const facet = facets.find((facet) => facet.attribute === attribute);
    const existingFilter = route.query[facet.paramName] ?? "";
    const existingFilterArray = existingFilter.length > 0 ? existingFilter.split(",") : [];
    existingFilterArray.push(encodeURIComponent(item.label));
    const finalizeParam = existingFilterArray.join(",");
    return {
      name: "student-management",
      params: { ...route.params, page: page, oktaId: undefined },
      query: {
        ...route.query,
        [facet.paramName]: finalizeParam,
      },
    };
  };

  const singleLink = (item, attribute, page = "listing") => {
    const facet = facets.find((facet) => facet.attribute === attribute);
    return {
      name: "student-management",
      params: { ...route.params, page: page, oktaId: undefined },
      query: {
        ...route.query,
        [facet.paramName]: encodeURIComponent(item.label),
      },
    };
  };

  const resetLink = (attribute, page = "listing") => {
    const facet = facets.find((facet) => facet.attribute === attribute);
    return {
      name: "student-management",
      params: { ...route.params, page: page, oktaId: undefined },
      query: {
        ...route.query,
        [facet.paramName]: undefined,
        ts: Date.now(),
      },
    };
  };

  return { listingLink: navigationLink, singleLink: singleLink, resetLink: resetLink };
};
